import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { User } from '../interfaces/user';

export const userEvents = eventGroup({
  source: 'User',
  events: {
    loadUserSuccess: type<{ user: User }>(),
    clearUser: type<void>(),
  },
});
